<template>
  <section style="padding: 60px 0px">
    <bl-text-av tag="h2" variation="heading-42" weight="bold" align="center" style="margin-bottom: 58px;">
      {{ $options.articleList.title }}
    </bl-text-av>

    <div v-if="mutualFundArticles" style="padding: 0px 110px 0px;">
      <bl-carousel-mv :gutter="24" :item-per-slide="2" navigation-top-position="30%" :slide-distance="2">
        <bl-carousel-slide-mv v-for="(article, index) in mutualFundArticles" :key="index" style="width: 467px;">
          <a :href="buildArticleUrl(article)" target="_blank">
            <div style="overflow: hidden; height: 172px; width: 100%;">
              <img :src="article.thumbnail_url" :alt="article.title" style="width: 100%; height: auto;" />
            </div>

            <bl-text-av class="mb-8 mt-20" variation="body-16" color="subdued">{{
              article.posting_date | formatDate
            }}</bl-text-av>
            <bl-text-av tag="h3" variation="subheading-20" :ellipsis="2">{{ article.title }}</bl-text-av>
          </a>
        </bl-carousel-slide-mv>
      </bl-carousel-mv>

      <div style="text-align: center;">
        <bl-button-av
          variation="outline"
          size="large"
          fullwidth
          :href="$options.articleList.otherArticle.url"
          style="margin-top: 60px;"
        >
          {{ $options.articleList.otherArticle.text }}
        </bl-button-av>
      </div>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { ArticleList as articleList } from 'shared/modules/seo/Homepage';
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import BlButtonAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlButtonAv';
import BlCarouselMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlCarouselMv';
import BlCarouselSlideMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlCarouselSlideMv';
import dayjs from 'dayjs';

export default {
  name: 'ArticleList',

  articleList,

  filters: {
    formatDate(val) {
      return dayjs(val).format('DD MMMM YYYY');
    },
  },

  components: {
    BlTextAv,
    BlButtonAv,
    BlCarouselMv,
    BlCarouselSlideMv,
  },

  computed: {
    mutualFundArticles() {
      return this.$store.state.server.mutualFundArticles;
    },

    isSSR() {
      return this.$root.isSSR;
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundArticles) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundArticles');
    }
  },

  methods: {
    buildArticleUrl(article) {
      const category = article.categories[0];
      return `${process.env.BUKAREVIEW_HOST}/${category.slug}/${article.slug}-${article.id}`;
    },
  },
};
</script>
